import hcSticky from "hc-sticky";

export default class StickyContent {
  constructor(view) {
    this.view = view;
    this.$receptor = this.view.querySelector(".jsStickTo--receptor");

    if (this.$receptor != null) {
      this.instance = new hcSticky(
        this.view.querySelector(".jsStickTo--receptor"),
        {
          stickTo: this.view.querySelector(".jsStickTo--referer"),
          innerTop: -120,
          responsive: {
            980: {
              disable: true,
            },
          },
        }
      );
    }
  }
}
